import { Snowflake, WashingMachine, Droplets, Refrigerator, Wrench, Wind, Zap, Fan } from "lucide-react";

export const ICONS: Record<string, typeof Snowflake> = {
  Snowflake, WashingMachine, Droplets, Refrigerator, Wrench, Wind, Zap, Fan,
};

export function ServiceIcon({ name, className }: { name: string; className?: string }) {
  const Icon = ICONS[name] || Wrench;
  return <Icon className={className} />;
}
